import {ApolloClient, from, HttpLink, InMemoryCache} from '@apollo/client'
import {RetryLink} from '@apollo/client/link/retry'
import {isNetworkError, sentryLinkConfig} from '@src/utility/sentry/misc'
import {getCustomUserAgent} from '@src/utility/userAgent'
import {SentryLink} from 'apollo-link-sentry'

const retryLink = new RetryLink({
  attempts: (count, _, error) => count <= 5 && isNetworkError(error?.toString?.()),
  delay: () => 1500
})

const sentryLink = new SentryLink(sentryLinkConfig)

const httpLink = new HttpLink({
  fetch: (uri, options) => {
    return fetch(uri, {
      ...options,
      headers: {
        ...options?.headers,
        'x-api-key': import.meta.env.VITE_PUBLIC_ONBOARDING_API_KEY ?? '',
        'x-pagaleve-user-agent': getCustomUserAgent()
      }
    }) // fetch needed for Fullstory record graphql payload
  },
  uri: `${import.meta.env.VITE_PUBLIC_ONBOARDING_GRAPHQL_API}`
})

const clientOnboarding = new ApolloClient({
  cache: new InMemoryCache(),
  connectToDevTools: import.meta.env.VITE_ENVIRONMENT === 'development',
  link: from([retryLink, sentryLink, httpLink])
})

export default clientOnboarding
